var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableRow",
    { staticClass: "automation-listing-table-loading-state__row" },
    [
      _vm._l(_vm.columns, function(column) {
        return [
          column.code === "name"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: column.maxWidth } },
                [_c("CompassSkeleton")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "date"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: {
                    fixed: column.fixed,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [_c("CompassSkeleton")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "status"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: {
                    alignContent: column.alignContent,
                    fixed: column.fixed,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [_c("CompassSkeleton", { attrs: { variant: "square" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "actions"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: {
                    fixed: column.fixed,
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth
                  }
                },
                [_c("CompassSkeleton", { attrs: { variant: "square" } })],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }